import src from "IMAGE";
export default { src, width: 512, height: 390, blurWidth: 0, blurHeight: 0};
